import React from "react";
import { Button, Spinner } from "react-bootstrap";
import CustomModal from "../../../Global/Modal/CustomModal";

const ApproveCoachesModal = ({
  show,
  onHide,
  coaches,
  onApproveCoach,
  onRejectCoach,
  loading,
}) => {
  const [loadingAction, setLoadingAction] = React.useState(null);
  const waitingCoaches =
    coaches?.filter(
      (coach) => coach.userData.userStatus === "waitingForOrgAccept"
    ) || [];

  const handleApprove = async (coach) => {
    setLoadingAction("approve");
    await onApproveCoach(coach);
    setLoadingAction(null);
  };

  const handleReject = async (coach) => {
    setLoadingAction("reject");
    await onRejectCoach(coach);
    setLoadingAction(null);
  };

  const footerButtons = [
    {
      title: "סגור",
      style: "grey",
      onClick: onHide,
      disabled: loadingAction !== null,
    },
  ];

  return (
    <CustomModal
      isOpen={show}
      onClose={onHide}
      title="אישור מאמנים חדשים"
      footerButtons={footerButtons}
      width={60}
      height={70}
    >
      {waitingCoaches.length === 0 ? (
        <p className="text-center" style={{ fontSize: "1.5rem" }}>
          אין מאמנים הממתינים לאישור
        </p>
      ) : (
        <div className="coach-list">
          {waitingCoaches.map((coach) => (
            <div
              key={coach.id}
              className="coach-item p-3 mb-2 border rounded"
              style={{ direction: "rtl" }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h3 className="mb-1">{coach.userData.userName}</h3>
                  <p className="mb-0 text-muted">
                    {coach.userData.userEmailAddress}
                  </p>
                </div>
                <div className="d-flex gap-2">
                  <Button
                    variant="danger"
                    size="sm"
                    style={{ width: "100px" }}
                    onClick={() => handleReject(coach)}
                    disabled={loadingAction !== null}
                  >
                    {loadingAction === "reject" ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "דחה"
                    )}
                  </Button>
                  <Button
                    variant="success"
                    size="sm"
                    style={{ width: "100px" }}
                    onClick={() => handleApprove(coach)}
                    disabled={loadingAction !== null}
                  >
                    {loadingAction === "approve" ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "אישור"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CustomModal>
  );
};

export default ApproveCoachesModal;
